export default (function () {

    function toggleMenu(e) {
        let target = e.target;
        // If elements inside the btn are targeted, amend target
        if (target.classList.contains('menu-toggle') === false) {
            target = target.closest('.menu-toggle');
        }
        let targets = document.querySelectorAll('[data-menu-toggle]');

        // Prepare vars
        const targetClass = target.getAttribute('data-target');
        const targetEl = document.querySelector(targetClass);
        const body = document.querySelector('.body-wrapper');

        // Amend DOM
        targets.forEach((tar)=>{
            tar.classList.toggle('is-active');
            (tar.getAttribute('aria-pressed') === 'false') ? tar.setAttribute('aria-pressed', 'true') : tar.setAttribute('aria-pressed', 'false');
        });
        // aria pressed stuff
        // (target.getAttribute('aria-pressed') === 'false') ? target.setAttribute('aria-pressed', 'true') : target.setAttribute('aria-pressed', 'false');
        targetEl.classList.toggle('is-active');
        body.classList.toggle('is-hidden');
    }

    function init() {
        const mobileMenu = document.querySelector('#mobileMenu');
        if (mobileMenu) {
            mobileMenu.style.opacity = '';
            mobileMenu.style.visibility = '';
        }

        const btnToggles = document.querySelectorAll('[data-menu-toggle]');
        if (btnToggles) {
            btnToggles.forEach((el)=>{
                el.addEventListener('click', e => toggleMenu(e));
            });
        }


        // Make sure we remove the menu from the screen before loading next page.
        // Necessary to avoid issues with the anchor link like #contactSection
        const menuLinks = document.querySelectorAll('#mobileMenu li a')

        for (let i = 0; i < menuLinks.length; i++) {
            menuLinks[i].addEventListener('click', (e) => {
                e.preventDefault(); // Prevent the default link behavior

                document.querySelector('[data-menu-toggle]').classList.toggle('is-active');
                document.querySelector('#mobileMenu').classList.toggle('is-active');
                document.querySelector('.body-wrapper').classList.toggle('is-hidden');

                // Add a delay before navigating to the link's target
                const href = e.target.getAttribute('href');
                setTimeout(() => {
                    window.location.href = href;
                }, 500);
            })
        }
    }

    init();
}());